import { render, staticRenderFns } from "./SimpleFolderList.vue?vue&type=template&id=9b3ba204&scoped=true"
import script from "./SimpleFolderList.ts?vue&type=script&lang=ts&external"
export * from "./SimpleFolderList.ts?vue&type=script&lang=ts&external"
import style0 from "./SimpleFolderList.vue?vue&type=style&index=0&id=9b3ba204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3ba204",
  null
  
)

export default component.exports